import { TabsStorage, type TabProps, type TabsState } from '@talos/kyoko';
import type { PropsWithChildren } from 'react';
import type { LayoutPanelApi } from '../../../types';
import { usePanelTabsStorage } from './usePanelTabsStorage';

type PanelTabsStorageProviderProps = PropsWithChildren<{
  panelApi: LayoutPanelApi;
  panelTabs: TabsState<TabProps> | undefined;
}>;

/**
 * Overrides tabs storage with a panel-param-backed implementation
 * so panel-based blotters persist tabs into dockview params.
 */
export function PanelTabsStorageProvider({ panelApi, panelTabs, children }: PanelTabsStorageProviderProps) {
  const storage = usePanelTabsStorage(panelTabs, panelApi);

  return <TabsStorage.Provider value={storage}>{children}</TabsStorage.Provider>;
}
